var _metadata, _sodipodiNamedview, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 25,
    width: 25,
    viewBox: "0 0 25 25",
    "data-name": "Camada 1",
    id: "Camada_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata74"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    showgrid: "false",
    id: "namedview72",
    guidetolerance: 10,
    gridtolerance: 10,
    objecttolerance: 10,
    borderopacity: 1,
    bordercolor: "#666666",
    pagecolor: "#ffffff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs63"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style61"
  }, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title65"
  }, "\xCDcones") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title65"
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1.46666,
      fill: "#fff"
    },
    id: "path67",
    d: "M 12.499986,24.966587 A 12.466587,12.466587 0 1 0 0.033413,12.499999 12.481254,12.481254 0 0 0 12.499986,24.966587 Z m 0,-1.613323 A 10.838598,10.838598 0 0 1 1.720068,13.702658 h 3.1533143 a 7.6412847,7.6412847 0 0 0 15.2532227,0 h 3.153311 a 10.838598,10.838598 0 0 1 -10.77993,9.650606 z m 0,-21.7065296 A 10.853264,10.853264 0 0 1 23.338584,12.104002 h -4.003976 a 0.80666151,0.80666151 0 0 0 -0.80666,0.850661 6.042628,6.042628 0 1 1 -12.0559087,0 A 0.79199493,0.79199493 0 0 0 6.2520403,12.368 0.86532782,0.86532782 0 0 0 5.6653773,12.133335 H 1.661402 A 10.853264,10.853264 0 0 1 12.499986,1.6467344 Z m 0,0",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1.46666,
      fill: "#fff"
    },
    id: "path69",
    d: "m 12.499986,17.721299 a 4.399972,4.399972 0 0 0 4.399972,-4.399972 c 0,-2.449317 -2.390652,-2.023987 -0.835995,-8.2572806 0.249332,-0.967994 -0.51333,-1.730656 -1.642656,-1.187993 -1.847988,0.865328 -6.3799457,5.573298 -6.3799457,9.4452736 a 4.399972,4.399972 0 0 0 4.3999577,4.399972 z M 14.259974,5.9000404 c -1.055993,5.4266326 1.055994,5.9839626 1.055994,7.3332876 a 2.815982,2.815982 0 0 1 -5.6319497,0 c 0,-2.625317 2.9332997,-6.0132956 4.5759557,-7.3332876 z m 0,0",
    className: "cls-1"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreas);
export default __webpack_public_path__ + "static/media/areas.d98e86432d1a12511c5ded99a3c2dee6.svg";
export { ForwardRef as ReactComponent };